import { ErrorHandler, inject, Injectable } from '@angular/core';

import { LoggingService } from './logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger = inject(LoggingService);

  handleError(error: Error): void {
    // chunk loading failure can happen when the deployed version changes as the user is using the app.
    // In this case, we want to reload the page so that the user gets the latest version of the app.
    const chunkFailedRegex = /^(?=.*\bchunk\b)(?=.*\bfailed\b).*$|\bdynamically imported module\b/;

    if (chunkFailedRegex.test(error?.message)) {
      this.logger.log('Chunk load failure detected, reloading the page...');
      this.reload();
    }
    this.logger.error(error);
  }

  reload(): void {
    window.location.reload();
  }
}
